import { render, staticRenderFns } from "./restverify.vue?vue&type=template&id=c2570f48&scoped=true&"
import script from "./restverify.vue?vue&type=script&lang=js&"
export * from "./restverify.vue?vue&type=script&lang=js&"
import style0 from "./restverify.vue?vue&type=style&index=0&id=c2570f48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2570f48",
  null
  
)

export default component.exports